<template>
<div id="o-app">
	<div id="o-app-layout" class="is-dimmed-background !bg-neutral-bg" :class="'ss-' + ScreenSize">
		<DesktopNavbar v-if="ScreenSize > 1 && !forceHide" :menu="navbarItems"/>
		<router-view
			v-if="!$root.$data.IsLoading"
			ref="CurrentController"
			class="o-app-component container mx-auto"
		/>
		<div v-else class="p-5">
			<Loader/>
		</div>
	</div>
</div>
</template>

<script lang="ts">
import { mapStores } from 'pinia';

import DesktopNavbar from '@globals/components/navigation/DesktopNavbar.vue';
import { useUserStore } from '@globals/stores/user';
import NavbarItem from '@globals/types/components/NavbarItem';

export default {
	name: 'PublicList',
	components: {
		DesktopNavbar,
	},
	data() {
		return {
			isPublicView: true,
		};
	},
	computed: {
		...mapStores(useUserStore),

		/**
		 * Zwraca elementy paska nawigacyjnego
		 */
		navbarItems() {
			if (!this.displayCustomerMenu) {
				return [];
			}

			return [
				{
					label: 'Zapytania',
					icon: 'list',
					travelTo: 'Rfps',
					badge: 'newRfps',
					badgeCount: 0,
					url: '/konto/zapytania',
				},
				{
					label: 'Kontakty',
					icon: 'chat-alt',
					travelTo: 'Contacts',
					badge: 'newContacts',
					badgeCount: 0,
					url: '/konto/kontakty',
				},
				{
					label: 'Usługi',
					icon: 'services',
					travelTo: 'Services',
					url: '/konto/uslugi-produkty',
				},
				{
					label: 'Płatności',
					icon: 'payments',
					travelTo: 'Settings',
					url: '/konto/ustawienia',
				},
				{
					label: 'Profil',
					icon: 'profile',
					travelTo: 'Profile',
					hideDesktop: true,
					url: '/konto/profil',
				},
			] as NavbarItem[];
		},
		displayCustomerMenu() {
			return !this.$root.$data.IsLoading && !!this.userStore.customerId && this.userStore.role !== 'BUYER';
		},
		forceHide() {
			return this.$route?.name === 'ChatBotWidget';
		},
	},
};

</script>
